// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__NrPP2","inputWrap":"CustomTip_inputWrap__3PsNl"};